import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_down",
  "use": "arrow_down-usage",
  "viewBox": "0 0 51 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 51 32\" id=\"arrow_down\">\r\n<title>arrow_down</title>\r\n<path fill=\"#ff6b4c\" d=\"M35.729 22.042l-1.956-1.956-8 8.178-8.178-8.178-1.778 1.956 9.956 9.956z\" />\r\n<path fill=\"#ff6b4c\" d=\"M24.529-0.003v28.622h2.667v-28.622h-2.667z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol